<div class="d-flex justify-content-between align-items-center">
  <div *ngIf="showInfo" class="items-info">
    Total Results: <b class="info-text mx-1">{{totalCount}}</b>
  </div>
  <div *ngIf="showInfo" class="items-info">
    Displaying <b class="info-text mx-1">{{pageSize < totalCount ? pageSize : totalCount}}</b> items per page.
  </div>
  <div *ngIf="!showInfo"></div>
  <ngb-pagination class="mr-2" [collectionSize]="totalCount" [(page)]="page" [pageSize]="pageSize"
    [maxSize]="paginatorSize" [rotate]="true" (pageChange)="selectPage(page)" [boundaryLinks]="true">
    <ng-template ngbPaginationPrevious>
      <span class="page-switcher">&lt; Prev</span>
    </ng-template>
    <ng-template ngbPaginationNext>
      <span class="page-switcher">Next &gt;</span>
    </ng-template>
    <ng-template ngbPaginationFirst>
      <span class="page-switcher">&lt;&lt;</span>
    </ng-template>
    <ng-template ngbPaginationLast>
      <span class="page-switcher">&gt;&gt;</span>
    </ng-template>
    <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
  </ngb-pagination>
</div>